import React, { useState } from 'react';
import { withNurseryContext } from '../../contexts/NurseryContext';
import { uniqueId } from '../../utils/helpers';
import ShopifyBuy from '../Shopify/ShopifyBuy';
import ShopifyMoreOptions from '../Shopify/ShopifyMoreOptions';
import { AttributeIcon, PlantSize, Zones } from '../../themes/icons/attributes';
export const setWaterIcons = (attr) => {
    let iconList = [];
    if (attr.length > 1) {
        const singleIcons = [];
        const rangeIcons = [];
        attr.forEach((item) => {
            if (item === 'dry in winter'
                || item === 'dry when dormant'
                || item === 'dry in summer') {
                singleIcons.push(item);
            }
            else {
                rangeIcons.push(item);
            }
        });
        if (rangeIcons.length > 1) {
            const attr1 = rangeIcons[0];
            const attr2 = rangeIcons[rangeIcons.length - 1];
            const attr1Id = `${attr1.replace(/ /g, '_')}`;
            const attr2Id = `${attr2.replace(/ /g, '_')}`;
            const elem = (React.createElement("li", { key: uniqueId(attr1Id), className: "range" },
                React.createElement(AttributeIcon, { name: attr1Id, className: "icn top" }),
                React.createElement(AttributeIcon, { name: attr2Id, className: "icn bottom" }),
                React.createElement("span", { className: "label" },
                    attr1,
                    ' ',
                    "-",
                    ' ',
                    attr2)));
            iconList.push(elem);
        }
        else if (rangeIcons.length === 1) {
            const attrId = `${rangeIcons[0].replace(/ /g, '_')}`;
            const elem = (React.createElement("li", { key: uniqueId(attrId), className: "single" },
                React.createElement(AttributeIcon, { name: attrId, className: "icn" }),
                React.createElement("span", { className: "label" }, rangeIcons[0])));
            iconList.push(elem);
        }
        if (singleIcons.length > 0) {
            const singleLi = singleIcons.map((item) => {
                const attrId = `${item.replace(/ /g, '_')}`;
                return (React.createElement("li", { key: uniqueId(attrId), className: "single single__water" },
                    React.createElement(AttributeIcon, { name: attrId, className: "icn" }),
                    React.createElement("span", { className: "label" }, item)));
            });
            iconList = iconList.concat(singleLi);
        }
    }
    else {
        const attrId = `${attr[0].replace(/ /g, '_')}`;
        const elem = (React.createElement("li", { key: uniqueId(attrId), className: "single" },
            React.createElement(AttributeIcon, { name: attrId, className: "icn" }),
            React.createElement("span", { className: "label" }, attr[0])));
        iconList.push(elem);
    }
    return iconList;
};
export const setSunIcons = (attr) => {
    if (attr.length > 1) {
        const attr1 = attr[0];
        const attr2 = attr[attr.length - 1];
        const attr1Id = `${attr1.replace(/ /g, '_')}`;
        const attr2Id = `${attr2.replace(/ /g, '_')}`;
        const elem = (React.createElement("li", { key: uniqueId(attr1Id), className: "range" },
            React.createElement(AttributeIcon, { name: attr1Id, className: "icn top" }),
            React.createElement(AttributeIcon, { name: attr2Id, className: "icn bottom" }),
            React.createElement("span", { className: "label" },
                attr1,
                ' ',
                "-",
                ' ',
                attr2)));
        return elem;
    }
    const attrId = `${attr[0].replace(/ /g, '_')}`;
    const elem = (React.createElement("li", { key: uniqueId(attrId), className: "single" },
        React.createElement(AttributeIcon, { name: attrId, className: "icn" }),
        React.createElement("span", { className: "label" }, attr[0])));
    return elem;
};
const SearchResultsItem = ({ data, onAddToShopifyCart, isAvailable, index, isNursery, nurserySlug, }) => {
    var _a, _b;
    const [openOptions, setOpenOptions] = useState(false);
    let relatedUrl = `/plants/${data.django_pk}/${data.slug}/`;
    if (isNursery && !isAvailable) {
        relatedUrl += `?nurseries=${nurserySlug}`;
    }
    const zones = data.zones_str;
    let mainTitle = null;
    let scientificName = null;
    let akaNames = [];
    mainTitle = data.primary_name;
    scientificName = data.scientific_name;
    akaNames = data.aka_names;
    let scientificNameEl = null;
    if (scientificName) {
        scientificNameEl = (React.createElement("p", { className: "plant__name_scientific" },
            "Scientific Name:",
            ' ',
            scientificName));
    }
    const plantType = data.plant_type;
    const height = data.dimensions.H;
    const width = data.dimensions.W;
    let plantSize;
    let heightEl;
    let widthEl;
    if (height) {
        heightEl = (React.createElement("p", null,
            React.createElement("span", { className: "key" }, "Height: "),
            React.createElement("span", { className: "value" }, height)));
    }
    if (width) {
        widthEl = (React.createElement("p", null,
            React.createElement("span", { className: "key" }, "Width: "),
            React.createElement("span", { className: "value" }, width)));
    }
    if (height || width) {
        plantSize = (React.createElement("div", { className: "plant__size" },
            React.createElement("h3", null,
                React.createElement(PlantSize, { className: "icn" }),
                "Size"),
            heightEl,
            widthEl));
    }
    let plantPhoto;
    let panelClass = 'panel searchpage__result';
    if (data.photo !== '') {
        plantPhoto = (React.createElement("a", { href: relatedUrl, title: mainTitle, className: "plant_name_link" },
            React.createElement("div", { className: "plant__photo" },
                React.createElement("picture", null,
                    React.createElement("source", { type: "image/webp", srcSet: data.photo_webp }),
                    React.createElement("source", { type: "image/jpeg", srcSet: data.photo }),
                    React.createElement("img", { loading: index === 0 ? 'eager' : 'lazy', src: data.photo, alt: data.photo_description })),
                React.createElement("div", { className: "plant__photo_hover" },
                    React.createElement("span", null, "View Plant")))));
    }
    else {
        panelClass += ' noPhoto';
        plantPhoto = (React.createElement("a", { href: relatedUrl, title: mainTitle, className: "plant_name_link" },
            React.createElement("div", { className: "plant__photo no_photo" },
                React.createElement("div", { className: "plant__photo_hover" },
                    React.createElement("span", null, "View Plant")))));
    }
    const buyBtn = (React.createElement(ShopifyBuy, { setOpenOptions: (value) => setOpenOptions(value), plant: data, onAddToShopifyCart: onAddToShopifyCart, mainTitle: mainTitle, isAvailable: isAvailable }));
    let waterElem = null;
    let sunElem = null;
    if (((_a = data.water_needs) === null || _a === void 0 ? void 0 : _a.length) > 0)
        waterElem = setWaterIcons(data.water_needs);
    if (((_b = data.sun_exposure) === null || _b === void 0 ? void 0 : _b.length) > 0)
        sunElem = setSunIcons(data.sun_exposure);
    return (React.createElement("div", { className: panelClass },
        React.createElement("div", { className: "plant__name_cont" },
            React.createElement("h2", { className: "pdp_related__title" },
                React.createElement("a", { href: relatedUrl, title: mainTitle, onBlur: () => { }, onFocus: () => { } }, mainTitle))),
        React.createElement("div", { className: "plant__name_aka" },
            scientificNameEl,
            React.createElement("p", null, akaNames.length > 0 && [
                React.createElement("span", { key: 0 }, "aka "),
                akaNames.join(', '),
            ])),
        React.createElement("div", { className: "plant__detail" },
            React.createElement("div", { className: "plant__info " },
                React.createElement("div", { className: "plant__type" },
                    React.createElement("h3", null,
                        React.createElement(AttributeIcon, { name: "attr1", className: "icn" }),
                        "Plant Type"),
                    React.createElement("p", null, plantType.replace(/\b[a-z]/g, (x) => x.toUpperCase()))),
                React.createElement("div", { className: "plant__zones" },
                    React.createElement("h3", null,
                        React.createElement(Zones, { className: "icn" }),
                        "Zones"),
                    React.createElement("p", null, zones)),
                plantSize),
            React.createElement("div", { className: "plant__info_single" },
                React.createElement("ul", { className: "plant__info_needs" },
                    sunElem,
                    waterElem))),
        plantPhoto,
        buyBtn,
        openOptions && (React.createElement(ShopifyMoreOptions, { openOptions: openOptions, setOpenOptions: (value) => setOpenOptions(value), djangoPk: data.django_pk, variants: data.variants.filter((variant) => variant.available), affiliatedLinks: data.affiliated_links, onAddToShopifyCart: onAddToShopifyCart, partnersData: data.nurseries, plantTitle: mainTitle }))));
};
export default withNurseryContext(SearchResultsItem);
